import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";
import LoadScript from "vue-plugin-load-script";

Vue.config.productionTip = false;

/* Chespik_Profle_server config*/

const firebaseConfig = {
  apiKey: "AIzaSyAogpRWNQhyuA2bP1C3lZSftTr1YYCKFZE",
  authDomain: "chespik-profile-server.firebaseapp.com",
  databaseURL: "https://chespik-profile-server.firebaseio.com",
  projectId: "chespik-profile-server",
  storageBucket: "gs://chespik-profile-server.appspot.com",
  messagingSenderId: "103536727618",
  appId: "1:103536727618:web:3f4a328faac6b2a629bfdb"
};

/* GlobalMediaHubli-ProfileServer config*/
/*
const firebaseConfig = {
  apiKey: "AIzaSyCHHZ4F0gSCADiAlbVxIy8u74tXGHYl34c",
  authDomain: "globalmediahubli-profileserver.firebaseapp.com",
  databaseURL: "https://globalmediahubli-profileserver.firebaseio.com",
  projectId: "globalmediahubli-profileserver",
  storageBucket: "gs://globalmediahubli-profileserver.appspot.com",
  messagingSenderId: "695345649433",
  appId: "1:695345649433:web:050f3ff1740951ab1c9788"
};
*/
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

Vue.config.performance = true;
Vue.use(LoadScript);

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  vuetify,

  components: {
    App
  }
});
